import {
  put, takeEvery, all, select, takeLatest,
} from 'redux-saga/effects';
import { operatorClient, authClient } from 'domain/HttpClients';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { getUser } from 'circe/authentication/selectors';
import * as I18n from 'circe/I18n';
import { AUTHORITIES } from 'domain/fuse/auth/constants';
import { startLoading, doneLoading } from 'domain/layout/actions';
import { show as showNotification } from 'circe/notifications/actions';
import {
  approveDriver,
  approveShipper,
  declineDriver,
  declineShipper,
  makeOperator,
  makeFinanceAdmin,
  revokeFinanceAdmin,
  revokeOperator,
  makeAccountAdmin,
  revokeAccountAdmin,
  makeFleetAdmin,
  makeProfile,
  makeProfileDone,
  revokeProfile,
  revokeProfileDone,
  assignReferenceId,
  activateProfileDone,
  activateProfile,
} from 'domain/operations/accountManagement/actions';

function* doApproveProfile(action) {
  const {
    payload: { id },
    type,
  } = action;
  yield put(
    startLoading(`APPROVE_PROFILE_${id}`, {
      urls: ['/drivers', '/shippers'],
    }),
  );
  const state = yield select();
  const resp = yield operatorClient.Patch(`/api/profiles/${id}/activate`).send();

  yield put(doneLoading(`APPROVE_PROFILE_${id}`));
  // type === Types.APPROVE_DRIVER ? yield put(refreshDrivers()) : yield put(refreshShippers());
}

function* doDeclineProfile(action) {
  const {
    payload: { id, role },
    type,
  } = action;

  yield put(
    startLoading(`DECLINE_PROFILE_${id}`, {
      urls: ['/drivers', '/shippers'],
    }),
  );

  const resp = yield operatorClient.Patch(`/api/profiles/${id}/suspend`).send();

  yield put(revokeProfileDone(id, role));

  yield put(doneLoading(`DECLINE_PROFILE_${id}`));
  // type === Types.DECLINE_DRIVER ? yield put(refreshDrivers()) : yield put(refreshShippers());
}

function* doActivateProfile(action) {
  const {
    payload: { id, role },
    type,
  } = action;

  yield put(
    startLoading(`ACTIVATE_PROFILE_${id}`, {
      urls: ['/drivers', '/shippers'],
    }),
  );

  const resp = yield operatorClient.Patch(`/api/profiles/${id}/activate`).send();

  yield put(activateProfileDone(id, role));

  yield put(doneLoading(`ACTIVATE_PROFILE_${id}`));
  // type === Types.DECLINE_DRIVER ? yield put(refreshDrivers()) : yield put(refreshShippers());
}

function* doMakeAndApproveProfile(role = AUTHORITIES.OPERATOR, action) {
  const state = yield select();
  const {
    payload: { id, role: assignedRole },
  } = action;

  yield put(
    startLoading(`MAKE_AND_APPROVE_PROFILE_${id}`, {
      urls: ['/drivers', '/shippers'],
    }),
  );

  try {
    const newProfile = yield operatorClient
      .Post(`/api/profiles/${id}/newProfile`)
      .withParams({ pid: id, role: assignedRole || role })
      .send();

    yield doApproveProfile({
      payload: {
        id: newProfile,
      },
    });
    yield put(makeProfileDone(id, assignedRole || role, newProfile));
  } catch (e) {
    console.error(e);
  }
  // yield put(refreshShippers());
  yield put(doneLoading(`MAKE_AND_APPROVE_PROFILE_${id}`));
}

function* watcher() {
  yield all([
    takeEvery(approveShipper().type, doApproveProfile),
    takeEvery(approveDriver().type, doApproveProfile),
    takeEvery(declineShipper().type, doDeclineProfile),
    takeEvery(declineDriver().type, doDeclineProfile),
    takeEvery(makeOperator().type, doMakeAndApproveProfile, AUTHORITIES.OPERATOR),
    takeEvery(revokeOperator().type, doDeclineProfile),
    takeEvery(makeFinanceAdmin().type, doMakeAndApproveProfile, AUTHORITIES.FINANCE_ADMIN),
    // takeEvery(approveFinanceAdmin().type, doApproveProfile),
    takeEvery(revokeFinanceAdmin().type, doDeclineProfile),
    takeEvery(makeAccountAdmin().type, doMakeAndApproveProfile, AUTHORITIES.ACCOUNT_ADMIN),
    takeEvery(revokeAccountAdmin().type, doDeclineProfile),
    takeEvery(makeFleetAdmin().type, doMakeAndApproveProfile, AUTHORITIES.FLEET_ADMIN),
    takeEvery(makeProfile().type, doMakeAndApproveProfile, null),
    takeEvery(activateProfile().type, doActivateProfile),
    takeEvery(revokeProfile().type, doDeclineProfile),
  ]);
}

export default watcher;
